import { render, staticRenderFns } from "./Infrahub.vue?vue&type=template&id=363ccfaa&scoped=true"
import script from "./Infrahub.vue?vue&type=script&lang=js"
export * from "./Infrahub.vue?vue&type=script&lang=js"
import style0 from "./Infrahub.vue?vue&type=style&index=0&id=363ccfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363ccfaa",
  null
  
)

export default component.exports